import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { HiMenuAlt3, HiX } from "react-icons/hi"; // hamburger icons


const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Set initial active link
  const [activeLink, setActiveLink] = useState(() => {
    const path = location.pathname;
    if (path === "/") return "home";
    if (path === "/service") return "services";
    if (path === "/about") return "about";
    if (path === "/contact") return "contact";
    return "home";
  });

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveLink("home");
    else if (path === "/service") setActiveLink("services");
    else if (path === "/about") setActiveLink("about");
    else if (path === "/contact") setActiveLink("contact");

    setMenuOpen(false); // close menu on route change
  }, [location.pathname]);

  const navLinks = [
    { to: "/", label: "HOME", key: "home" },
    { to: "/service", label: "SERVICES", key: "services" },
    { to: "/about", label: "ABOUT", key: "about" },
    { to: "/contact", label: "CONTACT", key: "contact" }
  ];

  return (
    <div>
      <div className="bg-gradient-to-t from-gray-800 to-black py-4 shadow-lg fixed z-50 top-2 left-4 lg:left-28 right-4 lg:right-28  rounded-lg">
        <div className="w-[90%] mx-auto flex justify-between items-center">
      
          <div className=" font-poppins flex items-center gap-2">
        
              <h1 className=" text-white text-[15px] tracking-widest">
              <span className="text-yellow-400">&lt;</span>Geo<span className="text-yellow-400">/&gt;</span>Code
            </h1>
          </div>

          {/* Desktop Nav */}
          <ul className="hidden md:flex gap-10 text-white font-medium text-[15px] tracking-widest relative">
            {navLinks.map((link) => (
              <li key={link.key}>
                <Link
                  to={link.to}
                  onClick={() => setActiveLink(link.key)}
                  className="relative"
                >
                  {link.label}
                  {activeLink === link.key && (
                    <motion.div
                      layoutId="underline"
                      className="absolute left-0 right-0 h-[2px] bg-yellow-400 rounded"
                      transition={{ duration: 0.3 }}
                    />
                  )}
                </Link>
              </li>
            ))}
          </ul>

          {/* Toggle Button - SM only */}
          <div className="md:hidden">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-white text-2xl focus:outline-none"
            >
              {menuOpen ? <HiX /> : <HiMenuAlt3 />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <motion.div
          initial={{ y: "-30vw", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ type: 'spring', duration: 0.8, stiffness: 120 }}
          className="md:hidden bg-black shadow-lg fixed z-50 py-6 top-24 left-4 lg:left-40 right-4 lg:right-40  rounded-lg">
          <ul className="flex flex-col gap-4  text-white text-sm font-medium">
            {navLinks.map((link) => (
              <li key={link.key} className=" text-center">
                <Link
                  to={link.to}
                  onClick={() => setActiveLink(link.key)}
                  className="block py-1"
                >
                  {link.label}
                  {activeLink === link.key && (

                    <motion.div
                      layoutId="underline"
                      className="w-20 mx-auto h-[2px] bg-yellow-400 mt-1 rounded"
                      transition={{ duration: 0.3 }}
                    />

                  )}
                </Link>
              </li>
            ))}
          </ul>
        </motion.div>
      )}
    </div>

  );
};

export default Navbar;